export default "__VITE_ASSET__C8o328ge__"